<template>
  <main class="project" v-if="project.title" :key="project.uid">
      <section v-scroll-to="{
        el: '#first',
        duration: 1000,
        offset: 0
      }" class="teaser-img">
            <img v-if="project.cover" :src="project.cover.url" :alt="project.title">
            <div class="teaser-text">
                  {{ project.title }} – {{  project.client }}
            </div>
      </section>
    <section id="first" class="pad-x pad-t pad-b">
      <div class="w-text" v-html="project.description"></div>
    </section>
    <template v-for="(section, index) in project.content">
      <section :key="index" v-if="section.type === 'gallery'" class="slideshow">
        <project-slideshow :files="section.gallery" />
      </section>
      <section :key="index" v-if="section.type === 'text'" class="pad-x pad-b pad-t">
        <div class="w-text" v-html="section.text"></div>
      </section>
      <section :key="index" v-if="section.type === 'video'" class="video">
        <video :src="section.video.url" autoplay muted loop playsinline></video>
      </section>
    </template>
    <section v-if="project.credit" class="pad-x pad-t pad-b">
      <div class="w-text uppercase caption">
            {{ project.title }}<br>
            ({{ project.year }}) {{ project.category }}<br>
            {{ project.client }}<br><br>
            <div v-html="project.credit"></div>
      </div>
      
    </section>
    <section v-if="related" class="col-four next-projects">
      <div class="next-project" v-for="project in related" :key="project.uid">
        <router-link :to="{ name: 'project', params: { id: project.uid } }">
          <img :src="project.files.small" :alt="project.title" />
          <div class="caption title uppercase">
            {{ project.title }}
          </div>
        </router-link>
      </div>
    </section>
  </main>
  <main v-else>
    <section class="col-2">Loading</section>
  </main>
</template>

<script>
const ProjectSlideshow = () =>
  import(/* webpackChunkName: "Footer" */ "@/components/ProjectSlideshow");
export default {
  name: "project",
  metaInfo() {
    return {
      title: "- " + this.project.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.project.description,
        },
      ],
    };
  },
  components: {
    ProjectSlideshow,
  },
  data() {
    return {
      showLogo: true,
    };
  },
  created() {
    this.$store.state.project = [];
  },
  mounted() {
    this.$store.dispatch("loadProject", this.$route.params.id);
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
    related() {
      let projects = this.$store.state.projects;
      let category = this.project.category;
      let filter = projects.filter((project) => project.category === category);
      return filter.slice(0, 4);
    },
  },
};
</script>

<style lang="scss">
.teaser-img {
      width:100%;
      height:100vh;
      position:relative;
      background:black;
      cursor: pointer;
      img {
            width:100%;
            height:100%;
            object-fit: cover !important;
      }
      .teaser-text {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            color:white;
            width:100%;
            text-align: center;
      }
}
.video {
  video {
    margin: auto;
    visibility: visible;
    opacity: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.next-projects {
  @media only screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr !important;
  }
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr !important;
  }
}
.next-project {
  position: relative;
  height: 25vw;
  @media only screen and (max-width: 768px) {
    height: 50vw;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
  }
}
</style>
